import { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import isNewMaterial from './is-new-material';
import isSaleAllowed from './is-sale-allowed';
import { isFreeMaterial } from './material-helper';
import { MATERIAL_LABELS, MaterialLabel } from './material-labels.constants';

const getLabel = (item: Material, countryCode?: string): MaterialLabel => {
    let label: MaterialLabel = '';

    const itemTitle = (item.title || '').toLocaleLowerCase();
    const isUkrInTitle = itemTitle.indexOf('ukrain') >= 0 || itemTitle.indexOf('ucrania') >= 0;
    const isUkraine = isUkrInTitle && world !== AVAILABLE_WORLDS.DE;

    if (isUkraine && !isFreeMaterial(item)) {
        label = MATERIAL_LABELS.DONATE;
    } else if (item.sale && isSaleAllowed(item, countryCode)) {
        label = MATERIAL_LABELS.SALE;
    } else if (item.bestInCategories && item.bestInCategories.length) {
        label = MATERIAL_LABELS.BESTSELLER;
    } else if (item.isHighQuality) {
        label = MATERIAL_LABELS.HIGH_QUALITY;
    } else if (isNewMaterial(item)) {
        label = MATERIAL_LABELS.NEW;
    }

    return label;
};

export default getLabel;
